export default function encodeSearchKeyword(keyword, isBcom) {
  let encoded = encodeURIComponent(keyword);
  // replace spaces
  const spacePlaceholder = isBcom ? '+' : '-';
  encoded = encoded.replaceAll('%20', spacePlaceholder);
  encoded = encoded.replaceAll('\'', '%27');

  return encoded;
}
